import { toast } from "react-toastify";

export function errorResponseHelper(err: any) {
    
    toast.error(err.response.data.message || err.response.data || "Something Went Wrong");
    return false
}

export function removeEmptyValues(obj: any) {
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null && v !== ""));
}